<template>
    <div>
        <form v-on:submit.prevent="newSendProtocol" enctype="multipart/form-data">
            <label for="">Nama Blast (Optional)</label>
            <input type="text" class="form-control" placeholder="Nama Blast" v-model="form.blast_name">
            <br>
            <div v-if="!form.multipleJadwal">
                <label for="">Pengirim</label>
                <multiselect v-model="form.sender" tag-placeholder="Pilih Device Pengirim"
                    placeholder="Pilih Device Pengirim" label="name" :custom-label="customLabel" track-by="id"
                    :options="device">
                </multiselect>
                <br>
            </div>
            <label for="">Tujuan Pesan</label>
            <select v-model="form.target_method" class="form-control">
                <option value="manual">Input Manual</option>
                <option value="contact">Group / Kontak Starsender</option>
                <option value="group">Group Whatsapp</option>
                <!-- <option value="csv" disabled>Import CSV</option> -->
            </select>
            <br>
            <div v-if="form.target_method == 'manual'">
                <label for="">Tujuan</label>
                <input type="text" class="form-control" placeholder="08xxxxxxxxx" v-model="form.receiver" required>
            </div>
            <div v-else-if="form.target_method == 'contact'">
                <label for="">Tujuan</label>

                <multiselect v-model="multiselect.value" tag-placeholder="Cari group atau kontak"
                    placeholder="Cari group atau kontak" label="label" track-by="id" :options="multiselect.options"
                    :multiple="true" :internal-search="false" :loading="multiselect.isLoading"
                    @search-change="loadReceiver" ref="selectedItems">
                    <template slot="beforeList">
                        <div>
                            <label @click="selectNone" class="selectAll">Deselect All</label>
                            <label @click="selectAll" class="selectAll">Select All</label>
                        </div>
                    </template>
                </multiselect>
                <div class="mt-3 p-3" style="background:#eef2ff;border-radius:8px;border:1px solid #c7d2fe;">
                    <div style="font-weight:600;margin-bottom:8px;"><i class="fa fa-bookmark"></i> Preset Grup</div>
                    <div class="d-flex" style="gap:8px;flex-wrap:wrap;align-items:center;">
                        <select v-model="broadcastPreset.selected" @change="applyPreset" class="form-control" style="max-width:240px;">
                            <option :value="null">-- Pilih Preset Tersimpan --</option>
                            <option v-for="p in broadcastPreset.list" :key="p.id" :value="p.id">{{ p.name }} ({{ presetCount(p) }})</option>
                        </select>
                        <button type="button" v-if="broadcastPreset.selected" @click="deletePreset(broadcastPreset.selected)" class="btn btn-sm btn-outline-danger">Hapus Preset</button>
                        <input type="text" v-model="broadcastPreset.newName" placeholder="Nama preset baru" class="form-control" style="max-width:200px;">
                        <button type="button" @click="savePreset" class="btn btn-sm btn-primary">💾 Simpan Pilihan</button>
                    </div>
                    <small class="text-muted d-block mt-1">Pilih grup di atas, beri nama, lalu Simpan. Lain kali tinggal pilih preset.</small>
                </div>
            </div>
            <div v-else-if="form.target_method == 'group'">
                <label for="">Tujuan</label>
                <div class="alert alert-warning" role="alert" v-if="checkSender() == 0">
                    <div class="alert-content">
                        <p><b>Silahkan Pilih Device Terlebih Dahulu</b></p>
                    </div>
                </div>
                <div class="alert alert-warning" role="alert" v-else-if="checkSender() > 1">
                    <div class="alert-content">
                        <p><b>Device Tidak Boleh Lebih Dari 1</b></p>
                    </div>
                </div>
                <div v-else-if="checkSender() == 1 && checkDeviceGroups() == 0">
                    <button v-if="loading.isGroupLoading" class="btn btn-primary" disabled>
                        <div class="spinner-border spinner" role="status"></div>
                        Loading...
                    </button>
                    <button v-else type="button" v-on:click="loadGroup(form.sender)" class="btn btn-primary">Load
                        Group</button>
                </div>
                <div v-else-if="checkSender() == 1 && checkDeviceGroups() > 0">
                    <multiselect v-model="multiselect.value" tag-placeholder="Cari group" placeholder="Cari group"
                        label="name" track-by="id" :options="deviceGroups" :multiple="true">
                        <template slot="beforeList">
                            <div>
                                <label @click="selectNoneGrup" class="selectAll">Deselect All</label>
                                <label @click="selectAllGrup" class="selectAll">Select All</label>
                            </div>
                        </template>
                    </multiselect>
                    <div class="mt-3 p-2" style="background:#f8f9fa;border-radius:6px;">
                        <label class="d-flex align-items-center mb-0" style="cursor:pointer;">
                            <input type="checkbox" v-model="form.tag_all" class="mr-2" style="width:18px;height:18px;">
                            <span><strong><i class="fa fa-users"></i> Tag Semua Member Grup</strong>
                                <small class="text-muted d-block">Saat dikirim, semua member di grup akan ter-notif @mention. Gunakan dengan bijak agar tidak dianggap spam.</small>
                            </span>
                        </label>
                    </div>
                <div class="mt-3 p-3" style="background:#eef2ff;border-radius:8px;border:1px solid #c7d2fe;">
                    <div style="font-weight:600;margin-bottom:8px;"><i class="fa fa-bookmark"></i> Preset Grup</div>
                    <div class="d-flex" style="gap:8px;flex-wrap:wrap;align-items:center;">
                        <select v-model="broadcastPreset.selected" @change="applyPreset" class="form-control" style="max-width:240px;">
                            <option :value="null">-- Pilih Preset Tersimpan --</option>
                            <option v-for="p in broadcastPreset.list" :key="p.id" :value="p.id">{{ p.name }} ({{ presetCount(p) }})</option>
                        </select>
                        <button type="button" v-if="broadcastPreset.selected" @click="deletePreset(broadcastPreset.selected)" class="btn btn-sm btn-outline-danger">Hapus Preset</button>
                        <input type="text" v-model="broadcastPreset.newName" placeholder="Nama preset baru" class="form-control" style="max-width:200px;">
                        <button type="button" @click="savePreset" class="btn btn-sm btn-primary">💾 Simpan Pilihan</button>
                    </div>
                    <small class="text-muted d-block mt-1">Pilih grup di atas, beri nama, lalu Simpan. Lain kali tinggal pilih preset.</small>
                </div>
                </div>
            </div>
            <br>
            <label for="">Jenis Pesan</label>
            <select v-model="form.message_type" class="form-control">
                <option value="text">Text / Media</option>
                <!-- <option v-if="form.target_method != 'group'" value="button">Button Message</option>
                <option v-if="form.target_method != 'group'" value="list">List Message</option> -->
            </select>
            <br>
            <div v-if="form.message_type == 'text'">
                <label for="">Text</label>
                <CustomTextArea v-model="form.text"></CustomTextArea>
                <br>
                <label> File (docx, xlsx, pdf, jpg, png, mp4) </label>
                <input ref="file" type="file" @change="onFileChange" class="form-control">
            </div>
            <div v-else-if="form.message_type == 'button'" class="card thick-border">
                <div class="card-body">
                    <h5 style="text-align: center;">BUTTON RESPONSE</h5>
                    <label> File (docx, xlsx, pdf, jpg, png, mp4) [Akan Dikirimkan Secara Terpisah]</label>
                    <input ref="file" type="file" @change="onFileChange" accept=".jpg,.jpeg,.png" class="form-control">
                    <br>
                    <label for="">Teks Button</label>
                    <CustomTextArea v-model="form.text"></CustomTextArea>
                    <br>
                    <button type="button" class="btn btn-primary btn-sm" v-on:click="addButton"
                        style="margin:5px">Tambah Button</button>
                    <button type="button" class="btn btn-danger btn-sm" v-on:click="deleteButton"
                        style="margin:5px">Hapus Button</button>

                    <br>
                    <div v-for="btn in button" v-bind:key="btn.id">
                        <br>
                        <div class="card thick-border">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="">Tipe Button</label>
                                        <select v-model="btn.type" class="form-control">
                                            <option value="quickReplyButton">Quick Reply (Tulisan Biasa)</option>
                                            <option value="urlButton">URL</option>
                                            <option value="callButton">Call Nomor Telepon</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                            <label for="">Display Text (Tulisan Pada Button)</label>
                                            <input type="text" class="form-control" v-model="btn.displayText" required>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div v-if="btn.type == 'urlButton'">
                                    <label for="">URL</label>
                                    <input type="text" class="form-control" v-model="btn.url" placeholder="https://"
                                        required>
                                </div>
                                <div v-else-if="btn.type == 'callButton'">
                                    <label for="">Nomor Telepon</label>
                                    <input type="text" class="form-control" v-model="btn.phoneNumber"
                                        placeholder="08xxxxxxxx" required>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <label for="">Footer</label>
                    <input type="text" v-model="form.footer" placeholder="Footer" class="form-control">
                </div>
                <div style="margin: 5px">
                    <i>* File / Gambar akan dikirimkan terlebih dahulu (secara terpsisah)</i>
                    <br>
                    <i>* Android Menampilkan Maksimal 3 Button</i>
                    <br>
                    <i>* Whatsapp Web Menampilkan Maksimal 5 Button</i>
                    <br>
                    <i>* IOS Unlimited Button</i>
                </div>
            </div>
            <div v-else-if="form.message_type == 'list'" class="card thick-border">
                <div class="card-body">
                    <h5 style="text-align: center;">LIST MESSAGE</h5>
                    <br>
                    <div class="row">
                        <div class="col-md-6">
                            <label> File (docx, xlsx, pdf, jpg, png, mp4) [Akan Dikirimkan Secara Terpisah]</label>
                            <input ref="file" type="file" @change="onFileChange" accept=".jpg,.jpeg,.png"
                                class="form-control">
                            <br>
                            <label for="">Judul List Message</label>
                            <input type="text" class="form-control" v-model="list.title" placeholder="Title" required>
                            <br>
                            <label for="">Deskripsi List Message</label>
                            <CustomTextArea v-model="form.text"></CustomTextArea>
                            <br>
                            <label for="">Button Text</label>
                            <input type="text" class="form-control" v-model="list.buttonText" placeholder="Klik Disini"
                                required>
                            <br>
                            <button type="button" class="btn btn-primary btn-sm" v-on:click="addListSection"
                                style="margin:5px">Tambah Pilihan</button>
                            <button type="button" class="btn btn-danger btn-sm" v-on:click="deleteListSection"
                                style="margin:5px">Hapus Pilihan</button>

                            <br>
                            <div v-for="ls in list.sections" v-bind:key="ls.id">
                                <br>
                                <div class="card thick-border">
                                    <div class="card-body">
                                        <label for="">Judul Pilihan</label>
                                        <input type="text" class="form-control" v-model="ls.title" placeholder="Title"
                                            required>
                                        <br>
                                        <label for="">Deskripsi Pilihan</label>
                                        <CustomTextArea v-model="ls.description"></CustomTextArea>
                                        <!-- <input type="text" class="form-control" v-model="ls.description" placeholder="Description" required> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <img style="padding:15px" src="@/assets/img/listmsg/1.png" />
                            <img style="padding:15px" src="@/assets/img/listmsg/2.png" width="371px" />

                        </div>
                    </div>
                </div>
                <div style="margin: 5px">
                    <i>* File / Gambar akan dikirimkan terlebih dahulu (secara terpsisah)</i>
                </div>
            </div>
            <br>
            <input v-model="form.send_now" class="checkbox" type="checkbox" id="sendnow">
            <label for="sendnow">
                <span for="sendnow" class="checkbox-text">&nbsp;Kirim pesan sekarang</span>
            </label>
            <br>
            <br>
            <div v-if="!form.send_now">
                <input v-model="form.multipleJadwal" class="checkbox" type="checkbox" id="multipleJadwal">
                <label for="multipleJadwal">
                    <span for="multipleJadwal" class="checkbox-text">&nbsp;Aktifkan multiple jadwal <span
                            class="badge badge-success">NEW</span>
                    </span>
                </label>
                <br>
                <div v-if="!form.multipleJadwal">
                    <label for="">Tanggal & Jam</label>
                    <v-date-picker class="inline-block h-full" v-model="form.date" mode="dateTime" is24hr>
                        <template v-slot="{ inputValue, togglePopover }">
                            <div>
                                <input @focus="togglePopover()" :value="inputValue" class="form-control" />
                            </div>
                        </template>
                    </v-date-picker>
                </div>
                <div v-else>
                    <div class="card thick-border">
                        <div class="card-body">
                            <h5 style="text-align: center;">MULTIPLE JADWAL</h5>
                            <br>
                            <div class="row">
                                <div class="col-md-6">
                                    <a v-on:click="addJadwal" class="btn btn-block btn-success text-white"
                                        style="display: inline-flex; margin: 5px">
                                        Tambah Jadwal
                                    </a>
                                </div>
                                <div class="col-md-6">
                                    <a v-on:click="deleteJadwal" class="btn btn-block btn-danger text-white"
                                        style="display: inline-flex; margin: 5px">
                                        Hapus Jadwal
                                    </a>
                                </div>
                            </div>
                            <br>
                            <div id="var">
                                <div v-for="vars in form.multipleDate" :key="vars.id">
                                    <div class="card thick-border">
                                        <div class="card-body">
                                            <h5 style="text-align: center;">Jadwal {{ vars.id }}</h5>
                                            <br>
                                            <label for="">Pengirim</label>
                                            <multiselect v-model="vars.sender" tag-placeholder="Pilih Device Pengirim"
                                                placeholder="Pilih Device Pengirim" label="name"
                                                :custom-label="customLabel" track-by="id" :options="device">
                                            </multiselect>
                                            <br>
                                            <label for="">Tanggal & Jam</label>
                                            <v-date-picker class="inline-block h-full" v-model="vars.date"
                                                mode="dateTime" is24hr>
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div>
                                                        <input @focus="togglePopover()" :value="inputValue"
                                                            class="form-control" />
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                            <br>
                                            <label for="">Limit</label>
                                            <input type="number" class="form-control" v-model="vars.limit" required>
                                        </div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                            <i>*Jika nomor tujuan broadcast melebihi limit yang di-setting, maka sisa nomor tujuan akan
                                ikut dikirimkan pada jadwal terakhir</i>
                        </div>
                    </div>
                </div>

                <br>
                <br>
            </div>
            
            <input v-model="form.useRotator" class="checkbox" type="checkbox" id="useRotator">
            <label for="useRotator">
                <span for="useRotator" class="checkbox-text">&nbsp;Aktifkan Device Rotator
                    <span class="badge badge-warning text-white">ANTI-BANNED 🛡️</span>
                </span>
            </label>
            <small class="form-text text-muted mb-2" v-if="!form.useRotator">
                <i class="fas fa-info-circle"></i> Centang untuk distribusi pesan ke beberapa device sekaligus (mengurangi risiko WA banned).
            </small>
            <div v-if="form.useRotator">
                <DeviceRotator v-model="form.rotator" :device-list="device" />
                <br>
            </div>
            <br>
            <label> Delay Interval (Detik) </label>
            <div class="row">
                <div class="col-md-5">
                    <input type="number" v-model="form.delay_start" placeholder="Dari" class="form-control">
                </div>
                <div class="col-md-2">
                    <center>
                        <b style="text-align: center;">SAMPAI</b>
                    </center>
                </div>
                <div class="col-md-5">
                    <input type="number" v-model="form.delay_end" placeholder="Sampai" class="form-control">
                </div>
            </div>
            <br>
            <div v-if="form.target_method == 'contact'">
                <i>- Anda bisa panggil nama whatsapp menggunakan [[NAME]] </i>
                <br>
                <i>- Anda bisa menggunakan dynamic string untuk generate random string, contoh : (halo|hai|pagi|siang)
                </i>
                <br>
                <i>- Anda bisa panggil nama kontak menggunakan {nama} </i>
                <br>
                <i>- Anda bisa panggil variabel menggunakan {var1}, {var2}, {var3}, dst </i>
                <br>
            </div>
            <div v-else>
                <i>- Anda bisa panggil nama whatsapp menggunakan [[NAME]] </i>
                <br>
            </div>
            <br>
            <input v-model="form.advanceSetting" class="checkbox" type="checkbox" id="advanceSetting">
            <label for="advanceSetting">
                <span for="advanceSetting" class="checkbox-text">&nbsp;Advance Setting <span
                        class="badge badge-success">NEW</span></span>
            </label>
            <div v-if="form.advanceSetting">
                <div class="card thick-border">
                    <div class="card-body">
                        <label for="">Skip</label>
                        <input type="number" class="form-control" v-model="form.skip">
                        <br>
                        <label for="">Limit</label>
                        <input type="number" class="form-control" v-model="form.limit">

                        <br>
                        <p>
                            - <b>Skip</b> adalah jumlah pesan yang akan dilewatkan dari awal
                            <br>- <b>Limit</b> adalah jumlah pesan yang akan dikirimkan
                            <br>- Misalnya ada 300 Pesan, Ingin mengirimkan pesan 100 - 200, maka Skip = 100 dan Limit = 100
                        </p>
                    </div>

                </div>
            </div>
            <br>
            <br>
            <button class="btn btn-primary btn-block">Kirim Pesan</button>
        </form>
        <modal name="send_progress" :height="'auto'" :adaptive="true" :scrollable="true" style="overflow-y: auto;">
            <div style="margin: 20px;text-align:center">
                <div class="spinner-border spinner" role="status"></div>
                <br>
                <h2>{{ progress }}%</h2>
                <br>
                <h3>SEDANG MEMPERSIAPKAN PESAN</h3>
                <p>Jangan Tutup Halaman Ini</p>
            </div>
        </modal>
    </div>
</template>

<script>
    import CustomTextArea from "@/components/module/CustomTextarea.vue";
    import Multiselect from 'vue-multiselect'

    import DeviceRotator from '@/components/forms/outgoing/DeviceRotator.vue'
    import moment from 'moment'
    import { v4 as uuidv4 } from 'uuid';

    export default {
        props: ['device'],
        components: {
            CustomTextArea,
            Multiselect,
            DeviceRotator
        },
        data() {
            return {
                form: {
                    sender: null,
                    receiver: "",
                    blast_name: "",
                    text: "",
                    file: "",
                    date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    footer: "",
                    message_type: "text",
                    target_method: "contact",
                    send_now: true,
                    delay_start: 30,
                    delay_end: 60,
                    multipleJadwal: false,
                    useRotator: false,
                    rotator: { mode: "round_robin", devices: [],
                    tag_all: false,
                },
                    multipleDate: [],
                    advanceSetting: false,
                    limit: -1,
                    skip: 0
                },
                page: {
                    one: true,
                    two: false,
                    three: false
                },
                multiselect: {
                    isLoading: true,
                    value: [],
                    options: []
                },
                progress: 0,
                contact: [],
                group: [],
                button: [],
                list: {
                    title: "",
                    buttonText: "",
                    sections: [],
                    section_index: 0
                },
                button_index: 0,
                loading: {
                    isGroupLoading: false,
                },
                deviceGroups: [],
                broadcastPreset: { list: [], selected: null, newName: "" }
            };
        },
        watch: {
            'form.sender': {
                handler() {
                    this.deviceGroups = []
                },
                deep: true
            },
        },
        mounted() {
            this.loadPresets();
            this.$root.$on("toggle_modal", (param) => {
                this.toggleModal(param);
            });

            this.getBlastList(1)
        },
        methods: {
            selectNone() {
                this.multiselect.value = [];
                this.$refs.selectedItems.deactivate();
            },
            selectAll() {
                this.multiselect.value = this.multiselect.options;
                this.$refs.selectedItems.deactivate();
            },
            selectNoneGrup() {
                this.multiselect.value = [];
                this.$refs.selectedItemsGrup.deactivate();
            },
            loadPresets() {
                const type = this.form.target_method === 'contact' ? 'contact' : 'group';
                this.$store.dispatch('broadcast_preset_list', { type: type })
                    .then(res => {
                        this.broadcastPreset.list = (res.data && res.data.data && res.data.data.presets) || [];
                    })
                    .catch(() => { this.broadcastPreset.list = []; });
            },
            presetCount(p) {
                try {
                    const arr = typeof p.items === 'string' ? JSON.parse(p.items) : (p.items || []);
                    return arr.length + ' grup';
                } catch (e) { return '0 grup'; }
            },
            applyPreset() {
                if (!this.broadcastPreset.selected) return;
                const p = this.broadcastPreset.list.find(x => x.id === this.broadcastPreset.selected);
                if (!p) return;
                let items = [];
                try { items = typeof p.items === 'string' ? JSON.parse(p.items) : (p.items || []); } catch (e) { items = []; }
                this.multiselect.value = items;
                this.$toast.success('Preset "' + p.name + '" dimuat (' + items.length + ' grup)');
            },
            async savePreset() {
                if (!this.broadcastPreset.newName || !this.broadcastPreset.newName.trim()) {
                    this.$toast.error('Isi nama preset dulu');
                    return;
                }
                if (!this.multiselect.value || this.multiselect.value.length === 0) {
                    this.$toast.error('Pilih grup dulu sebelum simpan preset');
                    return;
                }
                const type = this.form.target_method === 'contact' ? 'contact' : 'group';
                const deviceId = (this.form.sender && this.form.sender.length === 1) ? this.form.sender[0] : 0;
                try {
                    await this.$store.dispatch('broadcast_preset_create', {
                        name: this.broadcastPreset.newName.trim(),
                        type: type,
                        device_id: Number(deviceId) || 0,
                        items: JSON.stringify(this.multiselect.value)
                    });
                    this.$toast.success('Preset tersimpan');
                    this.broadcastPreset.newName = "";
                    this.loadPresets();
                } catch (err) {
                    this.$toast.error((err.response && err.response.data && err.response.data.message) || 'Gagal simpan preset');
                }
            },
            async deletePreset(id) {
                if (!confirm('Hapus preset ini?')) return;
                try {
                    await this.$store.dispatch('broadcast_preset_delete', { id: id });
                    this.$toast.success('Preset dihapus');
                    this.broadcastPreset.selected = null;
                    this.loadPresets();
                } catch (err) {
                    this.$toast.error('Gagal hapus preset');
                }
            },
            selectAllGrup() {
                this.multiselect.value = this.deviceGroups
                this.$refs.selectedItemsGrup.deactivate();
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            customLabel({
                name,
                status
            }) {
                return `${name} (${status})`
            },
            async getBlastList(limit, search = null) {
                this.multiselect.isLoading = true
                this.multiselect.options = []
                let option = []
                //let res = await this.$store.dispatch("contact_blast_list", {});
                let contact = await this.$store.dispatch("contact_list", {
                    columnFilters: {
                        name: search
                    },
                    page: 1,
                    limit: 100
                })
                let group = await this.$store.dispatch("group_list", {
                    columnFilters: {
                        name: search
                    },
                    page: 1,
                    limit: 500
                })

                contact = contact.data.data.contacts
                group = group.data.data.groups

                this.contact = contact
                this.group = group

                for (let i = 0; i < group.length; i++) {
                    option.push({
                        id: "g-" + group[i].id,
                        label: "[GROUP] " + group[i].name
                    })
                }

                for (let i = 0; i < contact.length; i++) {
                    option.push({
                        id: "c-" + contact[i].id,
                        label: "[CONTACT] " + contact[i].name + " (" + contact[i].number + ")"
                    })
                }
                this.multiselect.options = option
                this.multiselect.isLoading = false
            },
            loadReceiver(query) {
                this.getBlastList(100, query)
            },
            resetInput() {
                this.$refs.file.value = null;
                this.form = {
                    sender: "",
                    receiver: "",
                    blast_name: "",
                    text: "",
                    file: "",
                    date: "",
                    footer: "",
                    message_type: "text",
                    target_method: "contact",
                    send_now: true,
                    delay_start: 30,
                    delay_end: 60
                }
                this.list = {
                    title: "",
                    buttonText: "",
                    sections: [],
                    section_index: 0
                }
                this.button = []
                this.button_index = 0
                this.multiselect.value = []
            },
            onFileChange(e) {
                const selectedFile = e.target.files[0];
                this.form.file = selectedFile;
            },
            addButton() {
                this.button.push({
                    type: "quickReplyButton",
                    displayText: "",
                    url: "",
                    phoneNumber: "",
                    id: "id-" + (this.button_index + 1)
                })

                this.button_index += 1

                this.$toast.success("Tambah Button Sukses");
            },
            deleteButton() {
                if (this.button_index > 0) {
                    this.button.splice(-1)
                    this.button_index -= 1

                    this.$toast.success("Hapus Button Sukses");
                }
            },
            addListSection() {
                this.list.sections.push({
                    title: "",
                    description: "",
                    id: "id-" + (this.list.section_index + 1)
                })

                this.list.section_index += 1

                this.$toast.success("Tambah Pilihan Sukses");
            },
            deleteListSection() {
                if (this.list.section_index > 0) {
                    this.list.sections.splice(-1)
                    this.list.section_index -= 1

                    this.$toast.success("Hapus Pilihan Sukses");
                }
            },
            renderMessage(variable, text) {
                text = text.replaceAll("{nama}", variable['name'])

                if (variable?.data) {
                    let variableArray = JSON.parse(variable.data ?? [])

                    for (let i = 0; i < variableArray.length; i++) {
                        const element = variableArray[i];
                        text = text.replaceAll("{var" + element.id + "}", element.value)
                    }
                }

                return this.dynamicString(text)
            },
            dynamicString(message) {
                let match;
                while ((match = message.match(/\(([^()]*)\)/)) !== null) {
                    let split = match[1].split("|");
                    // if (split.length <= 1) {
                    // return message; // Hindari pengulangan tak terbatas jika tidak ada pilihan yang valid.
                    // }
                    const randomNumber = (min, max) => {
                        min = Math.ceil(min);
                        max = Math.floor(max);
                        return Math.floor(Math.random() * (max - min + 1)) + min;
                    };

                    let random = randomNumber(0, split.length - 1);
                    let replacer = split[random];
                    message = message.replace(match[0], replacer);
                }

                return message;
            },
            async buildSelectedContact(fileURL = null) {
                try {
                    let messages = []
                    let selected = this.multiselect.value
                    for (let i = 0; i < selected.length; i++) {
                        let split = selected[i].id.split("-")
                        let selector

                        if (split[0] == "g") {
                            selector = "group"
                        } else {
                            selector = "contact"
                        }

                        let res
                        if (selector == "group") {
                            res = await this.$store.dispatch("group_list_member", {
                                group_id: split[1],
                            });
                            res = res.data.data.members ?? []
                        } else {
                            let detail = await this.$store.dispatch("contact_detail", split[1])
                            res = [detail.data.data.contact] ?? []

                            // res = await this.$store.dispatch("group_list_member", {
                            //     group_id: split[1],
                            // });
                            // res = [this.contact[split[1]]]
                        }

                        for (let i = 0; i < res.length; i++) {
                            if (!res[i]?.number) {
                                continue
                            }

                            let message_to_push = {
                                message_type: this.form.message_type,
                                to: res[i].number,
                                text: await this.renderMessage(res[i], this.form.text),
                                file: fileURL,
                                footer: this.form.footer
                            }

                            if (this.form.message_type == "button") {
                                message_to_push.button = []

                                for (let i = 0; i < this.button.length; i++) {
                                    let button_to_push = {
                                        button_id: this.button[i].id.split("-")[1],
                                        button_type: this.button[i].type,
                                        display_text: this.button[i].displayText,
                                    }

                                    if (this.button[i].type == "urlButton") {
                                        button_to_push.button_action = this.button[i].url
                                    } else if (this.button[i].type == "callButton") {
                                        button_to_push.button_action = this.button[i].phoneNumber
                                    }

                                    message_to_push.button.push(button_to_push)
                                }
                            } else if (this.form.message_type == "list") {
                                message_to_push.list = {
                                    title: this.list.title,
                                    buttonText: this.list.buttonText,
                                    sections: this.list.sections
                                }
                            }

                            messages.push(message_to_push)
                        }
                    }

                    return messages
                } catch (err) {
                    console.log(err)
                    return []
                }
            },
            async buildSelectedGroup(fileURL = null) {
                let messages = []
                let selected = this.multiselect.value
                for (let i = 0; i < selected.length; i++) {
                    messages.push({
                        message_type: 'text',
                        to: selected[i].id,
                        text: this.form.text,
                        file: fileURL,
                        tag_all: this.form.tag_all || false,
                    })
                }

                return messages
            },
            async buildSelectedManual(fileURL) {
                let messages = []
                let message_to_push = {
                    message_type: this.form.message_type,
                    to: this.form.receiver,
                    text: this.form.text,
                    file: fileURL,
                }

                if (this.form.message_type == "button") {
                    message_to_push.button = []

                    for (let i = 0; i < this.button.length; i++) {
                        let button_to_push = {
                            button_id: this.button[i].id.split("-")[1],
                            button_type: this.button[i].type,
                            display_text: this.button[i].displayText,
                        }

                        if (this.button[i].type == "urlButton") {
                            button_to_push.button_action = this.button[i].url
                        } else if (this.button[i].type == "callButton") {
                            button_to_push.button_action = this.button[i].phoneNumber
                        }

                        message_to_push.button.push(button_to_push)
                    }
                } else if (this.form.message_type == "list") {
                    message_to_push.list = {
                        title: this.list.title,
                        buttonText: this.list.buttonText,
                        sections: this.list.sections
                    }
                }

                messages.push(message_to_push)

                return messages
            },
            async devideArray(array, limit = -1, skip = -1, delayStart, delayEnd, setDelay = true) {
                limit = parseInt(limit)
                skip = parseInt(skip)
                
                // Validasi input
                if (!array || array.length === 0) {
                    return []
                }
                
                // Tentukan start index
                let i = (skip == -1) ? 0 : Math.max(0, skip)
                
                // Tentukan end index - pastikan tidak melebihi array.length
                let len
                if (limit == -1) {
                    len = array.length
                } else {
                    len = Math.min(i + limit, array.length)
                }
                
                // Validasi delay range
                if (setDelay && delayStart !== undefined && delayEnd !== undefined) {
                    const start = parseInt(delayStart)
                    const end = parseInt(delayEnd)
                    if (start > end) {
                        console.warn('delayStart should be <= delayEnd')
                    }
                }
                
                let delay = 0
                let finalArray = []
                
                for (i; i < len; i++) {
                    if (!array[i]) continue

                    if (setDelay && delayStart !== undefined && delayEnd !== undefined) {
                        const start = parseInt(delayStart)
                        const end = parseInt(delayEnd)
                        // Generate random delay antara delayStart dan delayEnd
                        const randomDelay = Math.ceil(Math.random() * (end - start) + start)
                        array[i].delay = delay
                        delay += randomDelay
                    }

                    finalArray.push(array[i])
                }

                return finalArray
            },
            async newSendProtocol() {
                this.progress = 0
                this.toggleModal("send_progress")

                try {
                    let fileURL

                    if (this.form.date == "") {
                        this.form.date = moment().utc().valueOf()
                    } else {
                        this.form.date = moment(this.form.date).utc().valueOf()
                    }

                    if (this.form.file) {
                        this.progress = 15
                        const formData = new FormData();
                        formData.append('file', this.form.file)
                        let response = await this.$store.dispatch('cdn_upload', formData)
                        fileURL = response.data.data.url
                    }

                    let messages = []

                    this.progress = 50
                    if (this.form.target_method == "contact") {
                        //GET ALL CONTACT
                        messages = await this.buildSelectedContact(fileURL)
                    } else if (this.form.target_method == "group") {
                        messages = await this.buildSelectedGroup(fileURL)
                    } else if (this.form.target_method == "manual") {
                        messages = await this.buildSelectedManual(fileURL)
                    }

                    if (messages.length == 0) {
                        this.$toast.error("Tidak ada tujuan pesan")
                        this.toggleModal("send_progress")
                        this.progress = 0
                        return
                    }

                    if (this.$store.state.auth.package.message_quota != -1 && messages.length > this.$store.state
                        .auth.package.message_quota) {
                        this.$toast.error("Kuota pesan tidak mencukupi")
                        this.toggleModal("send_progress")
                        this.progress = 0
                        return
                    }

                    // Jika ada limit atau skip yang di-set, gunakan devideArray untuk memfilter
                    // Default: limit = -1 (semua), skip = 0 (tidak skip)
                    if (this.form.limit != -1 || this.form.skip != 0) {
                        messages = await this.devideArray(messages, this.form.limit, this.form.skip, 0, 0, false)
                        
                        // Validasi setelah filter
                        if (messages.length === 0) {
                            this.$toast.error("Tidak ada pesan setelah filter limit/skip")
                            this.toggleModal("send_progress")
                            this.progress = 0
                            return
                        }

                        if(messages.length != this.form.limit && this.form.limit != -1) {
                            this.$toast.error("Jumlah pesan tidak sesuai dengan limit")
                            this.toggleModal("send_progress")
                            this.progress = 0
                            return
                        }
                    }

                    // console.log("Skipped: " + this.form.skip)
                    // console.log("Limit: " + this.form.limit)
                    // console.log("Messages: " + messages.length)
                    // console.log("Messages: " + JSON.stringify(messages))
                    // return

                    this.progress = 70

                    //unique uuidv4 from library
                    const blastID = uuidv4()

                    let finalMessage = []
                    if (this.form.useRotator && this.form.rotator && this.form.rotator.devices && this.form.rotator.devices.length > 0) {
                        // === DEVICE ROTATOR: distribute messages across devices ===
                        const rotatorDevices = this.form.rotator.devices
                        const rotatorMode = this.form.rotator.mode || 'round_robin'
                        const baseSchedule = this.form.send_now ? moment().utc().valueOf() : this.form.date

                        let chunks = {}
                        rotatorDevices.forEach(d => { chunks[d.id] = [] })

                        if (rotatorMode === 'round_robin') {
                            // Interleave: msg 1->A, msg 2->B, msg 3->A, ... respecting per-device limit
                            const filled = {}
                            rotatorDevices.forEach(d => { filled[d.id] = 0 })
                            let pointer = 0
                            for (let mi = 0; mi < messages.length; mi++) {
                                let placed = false
                                for (let attempt = 0; attempt < rotatorDevices.length; attempt++) {
                                    const dev = rotatorDevices[(pointer + attempt) % rotatorDevices.length]
                                    if (filled[dev.id] < dev.limit) {
                                        chunks[dev.id].push(messages[mi])
                                        filled[dev.id]++
                                        pointer = (pointer + attempt + 1) % rotatorDevices.length
                                        placed = true
                                        break
                                    }
                                }
                                if (!placed) {
                                    // All devices reached limit, wrap around — assign to least-loaded
                                    const least = rotatorDevices.reduce((a, b) => filled[a.id] <= filled[b.id] ? a : b)
                                    chunks[least.id].push(messages[mi])
                                    filled[least.id]++
                                }
                            }
                        } else {
                            // Sequential batch: device A fills first, then B, etc.
                            let cursor = 0
                            for (let di = 0; di < rotatorDevices.length; di++) {
                                const dev = rotatorDevices[di]
                                const isLast = di === rotatorDevices.length - 1
                                const take = isLast ? (messages.length - cursor) : Math.min(dev.limit, messages.length - cursor)
                                if (take <= 0) continue
                                chunks[dev.id] = messages.slice(cursor, cursor + take)
                                cursor += take
                            }
                        }

                        // Build finalMessage payload per device
                        for (const dev of rotatorDevices) {
                            const rotatorChunk = chunks[dev.id] || []
                            if (rotatorChunk.length === 0) continue
                            finalMessage.push({
                                blast_name: this.form.blast_name,
                                blast_id: blastID,
                                device_id: dev.id,
                                schedule: baseSchedule,
                                broadcast: rotatorChunk,
                            })
                        }
                    } else if (this.form.multipleJadwal) {
                        let skip = 0
                        for (let i = 0; i < this.form.multipleDate.length; i++) {
                            let limit = parseInt(this.form.multipleDate[i].limit)

                            if (i == this.form.multipleDate.length - 1) {
                                limit = -1
                            }

                            finalMessage.push({
                                blast_name: this.form.blast_name,
                                blast_id: blastID,
                                device_id: this.form.multipleDate[i].sender.id,
                                schedule: moment(this.form.multipleDate[i].date).utc().valueOf(),
                                broadcast: await this.devideArray(messages, limit, skip, this.form
                                    .delay_start, this.form.delay_end)
                            })
                            skip += limit
                        }
                    } else {
                        finalMessage.push({
                            blast_name: this.form.blast_name,
                            blast_id: blastID,
                            device_id: this.form?.sender?.id,
                            schedule: this.form.date,
                            broadcast: await this.devideArray(messages, -1, -1, this.form.delay_start, this
                                .form.delay_end)
                        })
                    }

                    this.progress = 90

                    let sendMessage
                    for (let i = 0; i < finalMessage.length; i++) {
                        sendMessage = await this.$store.dispatch('outgoing_send', finalMessage[i])
                    }

                    this.progress = 100
                    this.resetInput()
                    this.$toast.success(sendMessage.data.message)
                    this.toggleModal("send_progress")
                    this.$root.$emit("refresh_package", true)
                    this.progress = 0
                } catch (err) {
                    this.resetInput()
                    this.toggleModal("send_progress")
                    this.$root.$emit("refresh_package", true)
                    this.progress = 0
                    this.$toast.error(err?.response?.data?.message)
                }
            },
            async sendSingle() {
                this.progress = 0
                this.toggleModal("send_progress")

                try {
                    const formData = new FormData();
                    let url = ""

                    if (this.form.date == "") {
                        this.form.date = moment().utc().valueOf()
                    } else {
                        this.form.date = moment(this.form.date).utc().valueOf()
                    }

                    if (this.form.file) {
                        formData.append('file', this.form.file)
                        let response = await this.$store.dispatch('cdn_upload', formData)
                        url = response.data.data.url
                    }
                    this.progress = 30

                    if (this.form.multipleJadwal == true) {
                        if (this.form.multipleDate.length <= 0) {
                            this.$toast.error("Tidak ada jadwal pesan")
                            this.toggleModal("send_progress")
                            this.progress = 0
                            return
                        }


                    }
                    let message = {
                        //device_id: this.form.sender,
                        schedule: this.form.date,
                        broadcast: []
                    }

                    let delay_int = 0

                    if (this.form.target_method == "contact") {
                        let selected = this.multiselect.value
                        let progress_counter = 50 / selected.length

                        for (let i = 0; i < selected.length; i++) {
                            let split = selected[i].id.split("-")
                            let selector

                            if (split[0] == "g") {
                                selector = "group"
                            } else {
                                selector = "contact"
                            }

                            let res

                            if (selector == "group") {
                                res = await this.$store.dispatch("group_list_member", {
                                    group_id: split[1],
                                });
                                res = res.data.data.members ?? []
                            } else {
                                res = [this.contact[split[1]]]
                            }


                            this.progress = this.progress + progress_counter
                            for (let i = 0; i < res.length; i++) {
                                if (!res[i]?.number) {
                                    continue
                                }

                                let message_to_push = {
                                    message_type: this.form.message_type,
                                    to: res[i].number,
                                    text: await this.renderMessage(res[i], this.form.text),
                                    file: url,
                                    delay: delay_int,
                                    footer: this.form.footer
                                }

                                if (this.form.message_type == "button") {
                                    message_to_push.button = []

                                    for (let i = 0; i < this.button.length; i++) {
                                        let button_to_push = {
                                            button_id: this.button[i].id.split("-")[1],
                                            button_type: this.button[i].type,
                                            display_text: this.button[i].displayText,
                                        }

                                        if (this.button[i].type == "urlButton") {
                                            button_to_push.button_action = this.button[i].url
                                        } else if (this.button[i].type == "callButton") {
                                            button_to_push.button_action = this.button[i].phoneNumber
                                        }

                                        message_to_push.button.push(button_to_push)
                                    }
                                } else if (this.form.message_type == "list") {
                                    message_to_push.list = {
                                        title: this.list.title,
                                        buttonText: this.list.buttonText,
                                        sections: this.list.sections
                                    }
                                }

                                message.broadcast.push(message_to_push)

                                delay_int += Math.ceil(Math.random() * (parseInt(this.form.delay_end) - parseInt(
                                    this.form.delay_start)) + parseInt(this.form.delay_start))
                            }
                        }
                    } else if (this.form.target_method == "manual") {
                        let message_to_push = {
                            message_type: this.form.message_type,
                            to: this.form.receiver,
                            text: this.form.text,
                            file: url,
                            delay: delay_int,
                        }

                        if (this.form.message_type == "button") {
                            message_to_push.button = []

                            for (let i = 0; i < this.button.length; i++) {
                                let button_to_push = {
                                    button_id: this.button[i].id.split("-")[1],
                                    button_type: this.button[i].type,
                                    display_text: this.button[i].displayText,
                                }

                                if (this.button[i].type == "urlButton") {
                                    button_to_push.button_action = this.button[i].url
                                } else if (this.button[i].type == "callButton") {
                                    button_to_push.button_action = this.button[i].phoneNumber
                                }

                                message_to_push.button.push(button_to_push)
                            }
                        } else if (this.form.message_type == "list") {
                            message_to_push.list = {
                                title: this.list.title,
                                buttonText: this.list.buttonText,
                                sections: this.list.sections
                            }
                        }

                        message.broadcast.push(message_to_push)
                    } else if (this.form.target_method == "group") {
                        let selected = this.multiselect.value
                        for (let i = 0; i < selected.length; i++) {
                            message.broadcast.push({
                                message_type: 'text',
                                to: selected[i].id,
                                text: this.form.text,
                                file: url,
                                delay: delay_int,
                            })
                        }
                    }

                    if (message.broadcast.length == 0) {
                        this.$toast.error("Tidak ada tujuan pesan")
                        this.toggleModal("send_progress")
                        this.progress = 0
                        return
                    }

                    let finalMessage = []

                    //COUNT MESSAGE
                    let broadcastMessage = message.broadcast
                    let count = message.broadcast.length

                    if (this.$store.state.auth.package.message_quota != -1 && count > this.$store.state.auth.package
                        .message_quota) {
                        this.$toast.error("Kuota pesan tidak mencukupi")
                        this.toggleModal("send_progress")
                        this.progress = 0
                        return
                    }

                    const blastID = uuidv4()

                    if (count > 1) {
                        let sizePerDevice = Math.ceil(count / this.form.sender.length)
                        let chunkArray = this.chunkArrayInGroups(broadcastMessage, sizePerDevice)

                        for (let i = 0; i < this.form.sender.length; i++) {
                            finalMessage.push({
                                blast_name: this.form.blast_name,
                                blast_id: blastID,
                                device_id: this.form?.sender[i]?.id,
                                schedule: this.form.date,
                                broadcast: chunkArray[i]
                            })
                        }
                    } else {
                        finalMessage.push({
                            blast_name: this.form.blast_name,
                            blast_id: blastID,
                            device_id: this.form?.sender[0]?.id,
                            schedule: this.form.date,
                            broadcast: message.broadcast
                        })
                    }

                    let sendMessage
                    for (let i = 0; i < finalMessage.length; i++) {
                        sendMessage = await this.$store.dispatch('outgoing_send', finalMessage[i])
                    }

                    this.progress = 100
                    this.resetInput()
                    this.$toast.success(sendMessage.data.message)
                    this.toggleModal("send_progress")
                    this.$root.$emit("refresh_package", true)
                    this.progress = 0
                } catch (err) {
                    this.resetInput()
                    this.toggleModal("send_progress")
                    this.$root.$emit("refresh_package", true)
                    this.progress = 0
                    this.$toast.error(err?.response?.data?.message)
                }
            },
            chunkArrayInGroups(arr, size) {
                var myArray = [];
                for (let i = 0; i < arr.length; i += size) {
                    myArray.push(arr.slice(i, i + size));
                }

                let lastDelay = []
                for (let i = 0; i < myArray.length; i++) {
                    lastDelay.push(myArray[i][myArray[i].length - 1].delay)
                }

                for (let i = 0; i < myArray.length; i++) {
                    if (i != myArray.length - 1) {
                        for (let j = 0; j < myArray[i + 1].length; j++) {
                            myArray[i + 1][j].delay -= lastDelay[i]
                        }
                    }
                }

                return myArray;
            },
            checkSender() {
                return this.form.sender ? true : false
            },
            checkDeviceGroups() {
                return this.deviceGroups.length
            },
            async loadGroup(device) {
                this.loading.isGroupLoading = true
                try {
                    this.deviceGroups = []
                    let res = await this.$store.dispatch("contact_load_group_device", {
                        id: parseInt(device.id)
                    });

                    this.deviceGroups = res.data.data.groups
                    for (let i = 0; i < this.deviceGroups.length; i++) {
                        this.deviceGroups[i].name = this.deviceGroups[i].name + " (" + this.deviceGroups[i].id + ")"
                    }
                    this.$toast.success("Load Group Sukses")
                } catch (err) {
                    this.$toast.error("Load Group Gagal")
                }
                this.loading.isGroupLoading = false
            },
            addJadwal() {
                this.form.multipleDate.push({
                    id: this.form.multipleDate.length + 1,
                    sender: this.form.sender,
                    date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    limit: null
                });
            },
            deleteJadwal() {
                this.form.multipleDate.splice(-1)
            },
        },
    };
</script>

<style scoped>
    .thick-border {
        border: 2px solid #6c6c6c !important;
    }

    .selectAll {
        display: inline-block;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
        padding: 0.5rem 1rem;
        border: 1px solid #e5e7eb;
        border-radius: 0.5rem;
        background-color: #ffffff;
        color: #374151;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        user-select: none;
    }

    .selectAll:hover {
        background-color: #10b981;
        color: white;
        border-color: #10b981;
        box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.3), 0 2px 4px -1px rgba(16, 185, 129, 0.2);
        transform: translateY(-1px);
    }

    .selectAll:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px 0 rgba(16, 185, 129, 0.2);
    }
</style>